import { useMemo } from 'react'
import { useSubscriptions } from './useSubscriptions'

/** Demo tier for new users with no subscriptions (used for hasRealActiveTier, isDemoMode). */
const NONE_TIER = { id: 'NONE', name: 'NONE' }

/**
 * Derives the active subscription tier from organization subscriptions and tiers list.
 * Used for subscription state (e.g. useSubscriptionState). Feature limits (getActiveTierFeature) are not used for now.
 *
 * @returns {{ activeTier: object|null, isDemoMode: boolean }}
 */
export function useActiveTier() {
  const { organizationSubscriptions, tiers } = useSubscriptions()

  return useMemo(() => {
    const subs = organizationSubscriptions || []
    const tierList = tiers || []

    if (subs.length === 0) {
      return { activeTier: NONE_TIER, isDemoMode: true }
    }

    const activeSubscription =
      subs.find(s => s.state === 'ACTIVE') ||
      subs.find(s => s.state === 'PAYMENT_PENDING') ||
      subs[0]

    if (!activeSubscription) {
      return { activeTier: null, isDemoMode: false }
    }

    const tier = tierList.find(t => t.id == activeSubscription.tier)
    if (tier) {
      return { activeTier: tier, isDemoMode: tier.name === 'NONE' }
    }

    return {
      activeTier: {
        id: activeSubscription.tier || 'CUSTOM',
        name: 'CUSTOM',
        isCustom: true,
      },
      isDemoMode: false,
    }
  }, [organizationSubscriptions, tiers])
}
